import React from "react";
import { CheckCircle2Icon, TargetIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { images, volumes } from "../data/landing";
export function Volumes() {
  return <section id="included" className="scroll-mt-4 bg-cream px-5 py-16 text-navy-900 sm:py-20" data-id="element-309" data-mp="184ezrwcqr64u">
      <div className="mx-auto max-w-5xl" data-id="element-310" data-mp="1c4yxb1188bri">
        <div className="mx-auto max-w-2xl text-center" data-id="element-311" data-mp="1c607l3af4u86">
          <p className="text-sm font-bold text-gold-600" data-id="element-312" data-mp="1zujizrorln4h">What's inside Denture Blueprint™</p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-313" data-mp="24tw344o94g3d">
            Six Professional Volumes to Help You Organize Your Complete Denture Assessment
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy-700" data-id="element-314" data-mp="1vt7qneeiansl">
            I've organized Denture Blueprint™ into six focused volumes so you can consult the material by topic instead of searching through one long, unstructured document. Each volume serves a specific purpose within your professional reference library.
          </p>
        </div>

        <img src={images.product} alt="The six Denture Blueprint volumes" className="mx-auto mt-8 w-full max-w-lg" data-id="element-315" data-mp="3o8f189k3z7mf" />

        <ol className="mt-10 space-y-6" data-id="element-316" data-mp="3jbg89uc6l6pt">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy-900/10" data-id="element-317" data-mp="22jgnduofuha">
              <div className="bg-navy-900 px-6 py-5 text-white" data-id="element-318" data-mp="3t9cj0l17hzne">
                <p className="text-sm font-extrabold text-gold-400" data-id="element-319" data-mp="b0byoprs9g8d">Volume {v.number}</p>
                <h3 className="mt-1 font-display text-2xl font-black leading-tight" data-id="element-320" data-mp="61ijmswulh63">{v.title}</h3>
                <p className="mt-2 text-base font-semibold text-navy-200" data-id="element-321" data-mp="kqeokh3lye2h">{v.subtitle}</p>
              </div>
              <div className="p-6 md:grid md:grid-cols-[1fr_1.1fr] md:gap-8" data-id="element-322" data-mp="fto9nx3jhoin">
                <p className="text-base leading-relaxed text-navy-700" data-id="element-323" data-mp="trcux61iqxo8">{v.intro}</p>
                <div className="mt-5 md:mt-0" data-id="element-324" data-mp="pqszq80ia44q">
                  <p className="text-sm font-bold text-navy-900" data-id="element-325" data-mp="ps43i7tybbvu">Inside this volume:</p>
                  <ul className="mt-3 space-y-2" data-id="element-326" data-mp="wv25wvtoy6os">
                    {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-navy-700" data-id="element-327" data-mp="11tltt1ruhsjs">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-328" data-mp="16r5a0783sfed" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
              <div className="mx-6 mb-6 flex gap-3 rounded-2xl bg-sand p-4" data-id="element-329" data-mp="1kj1wnvr05x3d">
                <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-330" data-mp="1kl4wf7hyj4la" />
                <p className="text-[15px] leading-snug text-navy-800" data-id="element-331" data-mp="1pgk7xsshsoej"><strong data-id="element-332" data-mp="1ugge9yonwrx9">The goal:</strong> {v.goal}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-333" data-mp="3rbcg8nerugw6">
          <CTAButton label="I Want All 6 Volumes Now" sub="One-time payment of $27 · Instant access" data-id="element-334" data-mp="3rc4ek5zr6sq5" />
        </div>
      </div>
    </section>;
}